import { Button, Grid, Icon } from '@material-ui/core';
import MyCollapse from 'components/Collapse';
import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import MyIcon from 'components/Icon';
import PermissionHide from 'components/PermissionHide';
import Truncate from 'components/Truncate';
import { functions } from 'helpers';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import CampaignForm from '../CampaignForm';
import TrackerForm from '../TrackerForm';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  active: boolean;
  product: any;
  campaign: any;
  changeActive: any;
  updateListCampaigns: any;
}
class QuickView extends Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      activeCampaignForm: false,
      activeTrackerForm: false,
    };
  }

  handleCloseQuickView = () => {
    this.props.changeActive();
  };

  openEditForm = () => {
    this.setState({ activeCampaignForm: true });
  };

  closeEditForm = (saved?: boolean) => {
    this.setState({ activeCampaignForm: false });
    if (saved === true) this.handleCloseQuickView();
  };

  openTrackerForm = () => {
    this.setState({ activeTrackerForm: true });
  };

  closeTrackerForm = () => {
    this.setState({ activeTrackerForm: false });
  };

  render() {
    // se o quickview estiver ativo, remove o scroll da page e deixa apenas nele
    this.props.active ? functions.removeScrollPage() : functions.addScrollPage();

    const product = this.props.product;
    const campaign = this.props.campaign;

    return (
      <div>
        <div className={'my-quickview --quickView-product' + (this.props.active ? ' -active' : '')}>
          <div className='my-quickview__head'>
            <Grid container alignItems='center' direction='row' justify='space-between'>
              <div className='my-quickview__title'>{product.title}</div>
              <div className='my-quickview__close' onClick={this.handleCloseQuickView}>
                <MyIcon name='icon-close' />
              </div>
            </Grid>
          </div>

          <div className='my-quickview__container'>
            <Grid container justify='space-between' alignItems='center'>
              <Grid item xs={4} sm={6}>
                <div className='product__name' title={campaign.title ? campaign.title : 'Produto desconhecido'}>
                  <Truncate count={40} final={'...'}>
                    {campaign.title ? campaign.title : 'Produto desconhecido'}
                  </Truncate>
                </div>
              </Grid>

              <Grid item xs={8} sm={6} style={{ textAlign: 'right' }}>
                <PermissionHide action='myeduzz:links:editar'>
                  <Button size='small' onClick={this.openEditForm} style={{ color: '#596375', fontSize: 12, fontWeight: 600 }}>
                    <Icon style={{ fontSize: 12, color: '#596375', marginRight: '0.5rem' }}>edit</Icon>
                    Editar
                  </Button>
                </PermissionHide>

                {/* <PermissionHide action='myeduzz:links:editar'>
                  <Button
                    size='small'
                    onClick={this.openTrackerForm}
                    style={{ color: '#596375', fontSize: 12, fontWeight: 600 }}
                  >
                    <Icon style={{ fontSize: 12, color: '#596375', marginRight: '0.5rem' }}>code</Icon>
                    Trackear
                  </Button>
                </PermissionHide> */}
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                {campaign.active ? (
                  <span className='tgreen'>
                    <strong>Ativa</strong>
                  </span>
                ) : (
                  <span className='tred'>Inativa</span>
                )}
              </Grid>
            </Grid>

            <div className='m24-only-desktop' />
            <div className='m24-only-tablet' />
            <div className='m48-only-mobile' />

            <Grid container spacing={2}>
              <Grid item sm={6} xs={12} style={{ padding: '5px 12px' }}>
                <div style={{ padding: 0, fontWeight: 600, color: '#192542', fontSize: '0.875rem' }}>
                  RPC A: <span style={{ float: 'right', fontWeight: 'normal' }}>{campaign.rpc_affiliate}</span>
                </div>
              </Grid>
              <Grid item sm={6} xs={12} style={{ padding: '5px 12px' }}>
                <div style={{ padding: 0, fontWeight: 600, color: '#192542', fontSize: '0.875rem' }}>
                  RPC P: <span style={{ float: 'right', fontWeight: 'normal' }}>{campaign.rpc_producer}</span>
                </div>
              </Grid>
              <Grid item sm={6} xs={12} style={{ padding: '5px 12px' }}>
                <div style={{ padding: 0, fontWeight: 600, color: '#192542', fontSize: '0.875rem' }}>
                  Cliques: <span style={{ float: 'right', fontWeight: 'normal' }}>{campaign.clicks}</span>
                </div>
              </Grid>
              <Grid item sm={6} xs={12} style={{ padding: '5px 12px' }}>
                <div style={{ padding: 0, fontWeight: 600, color: '#192542', fontSize: '0.875rem' }}>
                  Conversões: <span style={{ float: 'right', fontWeight: 'normal' }}>{campaign.conversion}</span>
                </div>
              </Grid>
            </Grid>

            <div className='m24-only-desktop' />
            <div className='m24-only-tablet' />
            <div className='m48-only-mobile' />

            <Grid>
              <MyCollapse title='Script de marcação' icon={<Icon style={{ fontSize: 16 }}>gps_fixed</Icon>} arrow={true} contentActive={false}>
                <CustomCopyToClipboard
                  style={{ width: '100%', fontSize: 11 }}
                  text={`<script>
                    (function(i,s,o,g,c,f,r,a,m)
                    {i['edzpx_c']=c;i['edzpx_a']=f;i['PxEdz']=r;i[r]=i[r]||
                    function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();
                    a=s.createElement(o),m=s.getElementsByTagName(o)[0]||
                    s.getElementsByTagName('head')[0];
                    e='https://e';g=e+'duzz'+'.'+String.fromCharCode(105, 110, 102, 111)+'/'+g;a.async=1;
                    a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script','dev/js/px.js','${campaign.key}',${localStorage.getItem(
                    'id'
                  )},'edzpx');</script>`}
                />
                <p style={{ marginTop: 5, fontSize: 14, color: '#888' }}>
                  Clique{' '}
                  <a
                    href='https://ajuda.eduzz.com/hc/pt-br/articles/1260807655830-Como-marcar-tr%C3%A1fego-com-script-'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    aqui
                  </a>{' '}
                  e veja instruções de como usar.
                </p>
              </MyCollapse>
            </Grid>

            <div className='m8' />

            <Grid>
              <MyCollapse title='Script de Funil Infinito' icon={<Icon style={{ fontSize: 16 }}>details</Icon>} arrow={true} contentActive={false}>
                <CustomCopyToClipboard
                  style={{ width: '100%', fontSize: 11 }}
                  text={`<script>
                    var funnel_key = '${campaign.key}';
                    var funnel_level = '0';
                    var field_email = 'email';
                    var edz_loadscript = document.createElement('script');
                    edz_loadscript.src = 'https://eduzz.com/dev/js/ea.js?v=1.0';
                    document.getElementsByTagName('head')[0].appendChild(edz_loadscript);
                    </script>`}
                />
                <p style={{ marginTop: 5, fontSize: 14, color: '#888' }}>
                  Clique{' '}
                  <a
                    href='https://ajuda.eduzz.com/hc/pt-br/articles/4402979200027-Como-configurar-o-funil-infinito-%C3%93rbita-'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    aqui
                  </a>{' '}
                  e veja instruções de como usar.
                </p>
              </MyCollapse>
            </Grid>
          </div>
        </div>
        <div className={this.props.active ? 'my-overlay -active' : 'my-overlay'} onClick={this.handleCloseQuickView}></div>
        {this.state.activeCampaignForm && (
          <CampaignForm
            open={this.state.activeCampaignForm}
            handleClose={this.closeEditForm}
            product={product}
            campaign={campaign}
            updateListCampaigns={this.props.updateListCampaigns}
          />
        )}
        {this.state.activeTrackerForm && (
          <TrackerForm open={this.state.activeTrackerForm} handleClose={this.closeTrackerForm} product={product} campaign={campaign} />
        )}
      </div>
    );
  }
}

export default connect()(QuickView);
